// extracted by mini-css-extract-plugin
export default {"bentoBoxHomepageContainer":"BentoBoxHomepage_bentoBoxHomepageContainer__X+bYV","defaaultTemplate":"BentoBoxHomepage_defaaultTemplate__yR1Hr"};